import { Outlet, Link, useLocation } from 'react-router-dom'
import { Shield, Search, Github, Menu, X } from 'lucide-react'
import { useState } from 'react'
import { cn } from '@/lib/utils'

export default function Layout() {
  const location = useLocation()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/images', label: 'Browse Images' },
  ]

  return (
    <div className="min-h-screen flex flex-col">
      <header className="sticky top-0 z-50 bg-dark-950/80 backdrop-blur-lg border-b border-dark-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 group">
              <Shield className="h-8 w-8 text-primary-500 group-hover:text-primary-400 transition-colors" />
              <span className="font-semibold text-lg">ArmoredForge</span>
            </Link>

            <nav className="hidden md:flex items-center gap-1">
              {navLinks.map(link => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={cn(
                    'btn-ghost',
                    location.pathname === link.path && 'text-white bg-dark-800'
                  )}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            <div className="flex items-center gap-3">
              <Link
                to="/search"
                className="p-2 text-dark-400 hover:text-white hover:bg-dark-800 rounded-lg transition-colors"
                aria-label="Search"
              >
                <Search className="h-5 w-5" />
              </Link>

              <a
                href="https://github.com/armoredgate/forge"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 text-dark-400 hover:text-white hover:bg-dark-800 rounded-lg transition-colors"
                aria-label="GitHub"
              >
                <Github className="h-5 w-5" />
              </a>

              <button
                className="md:hidden p-2 text-dark-400 hover:text-white"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                {mobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
              </button>
            </div>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden border-t border-dark-800 bg-dark-950">
            <nav className="px-4 py-2 space-y-1">
              {navLinks.map(link => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={cn(
                    'block px-3 py-2 rounded-lg transition-colors',
                    location.pathname === link.path
                      ? 'bg-dark-800 text-white'
                      : 'text-dark-300 hover:text-white hover:bg-dark-800'
                  )}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-dark-800 bg-dark-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-2 text-dark-400">
              <Shield className="h-5 w-5 text-primary-500" />
              <span>ArmoredForge by ArmoredGate</span>
            </div>

            <div className="flex items-center gap-6 text-sm text-dark-400">
              <a href="https://armoredgate.com/docs" className="hover:text-white transition-colors">
                Documentation
              </a>
              <a href="https://armoredgate.com/support" className="hover:text-white transition-colors">
                Support
              </a>
              <a href="https://github.com/armoredgate/forge" className="hover:text-white transition-colors">
                GitHub
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}
